export default {
  standard: '标准',
  pleaseEnterCodeOrName: '请输入代码或名称',
  code: '代码',
  classCode: '类别代码',
  className: '类别名称',
  parentClass: '上级类别',
  pleaseSelect: '请选择',
  tableName: '表名',
  identify: '标识',
  classDetail: '类别详情',
  classType: '类别类型',
  changeRecords: '变更记录',
  changeType: '变更类型',
  changeUser: '变更人',
  changeTime: '变更时间',
  changeDetail: '变更详情',
  isPrimary: '主键属性',
  isNull: '非空',
  nameAttribute: '名称属性',
  tagAttribute: '标签属性',
  standardAttribute: '标准属性',
  attributeCode: '属性代码',
  attributeType: '属性类型',
  referenceAttribute: '引用属性',
  length: '长度',
  decimalPoint: '精度',
  defaultValue: '默认值',
  columnName: '列名',
  unit: '单位',
  ruleExpression: '规则表达式',
  enterRuleExpression:
    '用大括号括起来的 class 属性（例如 {{xxx}} ），将被替换为等效的属性值，否则将被视为字符串',
  relationIdentify: '关联标识',
  createAttribute: '新增属性',
  attributeDetail: '属性详情',
  changeBefore: '变更前',
  changeAfter: '变更后',
  createClass: '新增类别',
  attributeName: '属性名称',
  editStatus: '修改状态',
  viewDetail: '查看详情',
  editClass: '编辑类别',
  deleteClass: '删除类别',
  editAttribute: '编辑属性',
  deleteAttribute: '删除属性',
  whtherPublishClass: '是否发布所选择的类别',
  pleaseEnterCode: '请输入代码',
  pleaseEnterMathesRule: '请输入符合规则的代码',
  onlyEnterNumbersGreaterThanEqual0: '只能输入大于等于0的数字',
  onlyEnterNumbersGreaterThanEqual1: '只能输入大于等于1的数字',
  changeStatusWorking: '确定将类别状态改为：工作中',
  deleteTheClass: '是否确定要删除该类别',
  selectClass: '请先选择类别',
  deleteClassAttribute: '是否确定要删除所选类别属性',
  deleteTheClassAttribute: '请选择需要删除的类别属性',
  deleteRecord: '是否确定要删除该字段',
  dataType: '数据类型',
  confirmDeleteAttribute: '是否确定要删除该属性',
  standardAttributeDetail: '标准属性详情',
  editStandaardAttribute: '编辑标准属性',
  createStandardAttribute: '新增标准属性',
  pleaseSelectAtLeaseOneTableHeader: '请至少选择一项表头',
  displayReferenceClassAttributeId: '引用显示属性',
  confirmDeleteClass: '确认要删除该类别?',
  pleaseDeleteChildClass: '请先删除子类',
  infoType: '信息类别',
  pleaseEnterInfoType: '请选择信息类别',
  viewStorageSet: '查看存储设置',
  allowExport: '允许导出',
  allowImport: '允许导入',
  allowUpdate: '允许更新',
  fieldName: '字段名',
  pleaseSelectTheClassToPublish: '请选择要发布的实体',
  tagAndDocumentCannotBePublishedSimultaneously: 'Tag和Document实体不能同时发布',
  publishSuccess: '发布成功',
  tip: '提示',
  yes: '是',
  no: '否',
  syncPublishTheClassAndChildrenSuccessfully: '同步发布实体及子实体成功',
  pleaseSelectTheClassToBeUnpublished: '请选择要取消发布的实体',
  unsubscribedClassSuccessfully: '取消发布实体成功',
  syncCancelPublishTheClassAndChildrenSuccessfully: '同步取消发布实体及子实体成功',
  canCelPublish: '取消发布',
}
